function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M10 15.5c4.97 0 9-3.134 9-7s-4.03-7-9-7-9 3.134-9 7c0 1.996 1.074 3.797 2.798 5.072.025.02.143.092.276.172.268.162.446.439.48.75l.425 3.816a.1.1 0 0 0 .165.066c.662-.572 3.41-2.924 3.8-2.924.348 0 .699.048 1.056.048z" stroke="#EC4978" strokeWidth="2" /></svg>;
});